import { createSelector } from 'reselect'

import { userTypes } from 'constants/user'

export const _userInfo = state => state.user.userInfo
export const _user = state => state.user
export const _userId = state => state.user.userInfo.user_id
export const _userType = state => state.user.type
export const _qrcodeData = state => state.user.qrcodeData
export const _userTokens = state => state.user.tokens

export const _isTeacher = createSelector(
    _userType,
    userType => userType === userTypes.TEACHER
)

export const _isStudent = createSelector(
    _userType,
    userType => userType === userTypes.STUDENT
)

export const getIsLocal = createSelector(
    _userId,
    (_, id) => id,
    (userId, id) => userId === id
)
